<mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
    <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
        <mat-card-title class="mat-mdc-card-title text-white">
            {{'SectorComparison'|translate}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-mdc-card-content text-center">
        <span class="tilte">{{'SelectSectorsToCompare'|translate}}</span>

        <div class="chip">
            <mat-chip-listbox selectable multiple>
                <mat-chip-option class="f-s-14" color="primary" *ngFor="let sector of AllSectors" [value]="sector.id"
                    (click)="ChooseSector(sector?.id)">
                    {{sector.name}}
                </mat-chip-option>
            </mat-chip-listbox>
        </div>

        <apx-chart [series]="columnChartOptions.series" [chart]="columnChartOptions.chart"
            [xaxis]="columnChartOptions.xaxis" [yaxis]="columnChartOptions.yaxis" [grid]="columnChartOptions.grid"
            [tooltip]="columnChartOptions.tooltip" [plotOptions]="columnChartOptions.plotOptions">
        </apx-chart>

        <mat-divider></mat-divider>
        <div class="row m-t-24">
            <div class="col-sm-12">
                <a (click)="Cancel()" class="btnClose">
                    {{ 'Back' | translate}}
                </a>
            </div>
        </div>
    </mat-card-content>
</mat-card>
